import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-realtime-tracking',
  templateUrl: './realtime-tracking.component.html',
  styleUrls: ['./realtime-tracking.component.scss']
})
export class RealtimeTrackingComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
